<template>
 <div style="width: 100%; height: 100%;">
   <div id="data-view">
     <div class="data">
       <div class="data-title">
         <top/>
         <dv-decoration-10 style="width:98%;height:5px;margin-left: 1%"/>
       </div>
       <div class="data-content">
         <div class="data-content-left">
           <left @callBackInfo="getTypeIndex"  ref="left"/>
         </div>
<!--         <div class="data-content-right" style="background-color: rgba(6, 30, 93, 0.2)">-->

<!--         </div>-->

<!--         v-if  或者  v-show-->
         <div class="data-content-right">
           <main-screen ref="mainScreen"  v-if="indexType == 1 ? true : false"/>

           <mete-real-data ref="meteRealData" v-if="indexType == 2 ? true : false"/>
           <mete-history-data ref="meteHistoryData" v-if="indexType == 3 ? true : false"/>

           <pest-real-data ref="pestRealData" v-if="indexType == 4 ? true : false"/>
           <pest-analyse-data ref="pestAnalyseData" v-if="indexType == 5 ? true : false"/>
           <pest-area-data ref="pestAreaData" v-if="indexType == 6 ? true : false"/>
<!--           <pest-trend-data ref="pestTrendData" v-if="indexType == 7 ? true : false"/>-->

           <spore-real-data ref="sporeRealData" v-if="indexType == 8 ? true : false"/>
           <spore-analyse-data ref="sporeAnalyseData" v-if="indexType == 9 ? true : false"/>

           <soil-real-data ref="soilRealData" v-if="indexType == 11 ? true : false"/>
           <soil-history-data ref="soilHistoryData" v-if="indexType == 12 ? true : false"/>

           <seed-data ref="seedData" v-if="indexType == 13 ? true : false"/>

           <inse-control ref="inseControl" v-if="indexType == 14 ? true : false"/>

           <inse-real-data ref="inseRealData" v-if="indexType == 15 ? true : false"/>

           <inse-history-data ref="inseHistoryData" v-if="indexType == 16 ? true : false"/>

           <water-fertilizer-info ref="waterFertilizerInfo" v-if="indexType == 17 ? true : false"/>

           <water-fertilizer-control ref="waterFertilizerControl" v-if="indexType == 18 ? true : false"/>
         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
  import left from "./Left"
  import top from "./Top"
  import mainScreen from "./MainScreen"
  import meteRealData from "./MeteRealData"
  import meteHistoryData from "./MeteHistoryData"
  import pestRealData from "./PestRealData"
  import pestAnalyseData from "./PestAnalyseData"
  import pestAreaData from "./PestAreaData"
  import pestTrendData from "./PestTrendData"
  import sporeRealData from "./SporeRealData"
  import sporeAnalyseData from "./SporeAnalyseData"
  import soilRealData from "./SoilRealData"
  import soilHistoryData from "./SoilHistoryData"
  import seedData from "./SeedData"
  import inseControl from "./InseControl"
  import inseRealData from  "./InseRealData"
  import inseHistoryData from "./InseHistoryData"
  import waterFertilizerInfo from "./WaterFertilizerInfo";
  import waterFertilizerControl from "./waterFertilizerControl";
  import {getAttributesServer} from "../../until/api/MeteSoil";
  import {userLogin} from "../../until/api/login";
  export default {
    name: 'Home',
    components:{
      left,
      top,
      mainScreen,
      meteRealData,
      meteHistoryData,
      pestRealData,
      pestAnalyseData,
      pestAreaData,
      pestTrendData,
      sporeRealData,
      sporeAnalyseData,
      soilRealData,
      soilHistoryData,
      seedData,
      inseControl,
      inseRealData,
      inseHistoryData,
      waterFertilizerInfo,
      waterFertilizerControl
    },

    data() {
      return {
        indexType: 0,
        spTokenTime: '',
        smTokenTime: '',
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      if(authority != 'TENANT_ADMIN') {//非管理员用户
        this.getSPUserPwd(customerId);//获取虫情孢子账户用户名密码
      }
      this.getSMToken();
      this.indexType = 1;
    },

    beforeDestroy() {
      //清空气象墒情时间
      clearInterval(this.spTokenTime);
      this.spTokenTime = null;

      //清空孢子虫情时间
      clearInterval(this.smTokenTime);
      this.smTokenTime = null;
    },

    methods: {
      /**
       * 获取虫情孢子账户用户名密码
       * @param customerId
       */
      getSPUserPwd(customerId) {
        let param = {"loginName":"","loginPwd":""};
        let nameFlg = false;
        let pwdFlg = false;
        getAttributesServer('CUSTOMER', customerId).then(response => {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key.toString() == 'loginName') {
              param.loginName = response.data[i].value;
              nameFlg = true;
            } else if(response.data[i].key.toString() == 'loginPwd') {
              param.loginPwd = response.data[i].value;
              pwdFlg = true;
            }
          }
          if(nameFlg && pwdFlg) {//用户名密码全部获取
            this.sporePestLogin(JSON.stringify(param));//获取虫情孢子token
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取虫情孢子token
       * @param param
       */
      sporePestLogin(param) {
        let spLogin = JSON.parse(param);
        let that = this;
        this.$SporeSoilCommon.getSpToken(spLogin, function (token) {
          //localStorage.setItem('spToken', token);
          localStorage.setItem('spToken', that.$commonFun.compileStr(token));
        });

        //每隔1.5小时获取一次虫情孢子token
        this.spTokenTime = window.setInterval(() => {
          setTimeout(() => {
            this.$SporeSoilCommon.getSpToken(spLogin, function (token) {
              //localStorage.setItem('spToken', token);
              localStorage.setItem('spToken', that.$commonFun.compileStr(token));
            })
          },0)
        }, 1000 * 60 * 60 * 1.5)
      },

      /**
       * 获取气象墒情token
       */
      getSMToken() {
        //let paramJson =  JSON.parse(localStorage.getItem('login')); //获取气象墒情用户名密码
        //let paramJson =  JSON.parse(this.$commonFun.unCompileStr(localStorage.getItem('login'))); //获取气象墒情用户名密码

        //每隔2小时获取一次气象墒情的token
        this.smTokenTime = window.setInterval(() => {
          let paramJson =  JSON.parse(this.$commonFun.unCompileStr(localStorage.getItem('login'))); //获取气象墒情用户名密码
          setTimeout(() => {
            userLogin(paramJson).then(response => {
              //localStorage.setItem('token', response.data.token);
              localStorage.setItem('token', this.$commonFun.compileStr(response.data.token));
            }).catch(error => {
              console.log("error", error)
            })
          }, 0)
        }, 1000 * 60 * 60 * 2);
      },

      /**
       * 点击切换画面
       * @param index
       */
      getTypeIndex(index) {
        this.indexType = index;
      }
    }
  }
</script>

<style lang="less">
  @import "../less/Home";
</style>



// WEBPACK FOOTER //
// src/components/view/Home.vue